<template>
    <div class="pt-3 pb-3">
        <vue-element-loading :active="show" spinner="ring" color="#006db3" size="128" text="กรุณารอสักครู่..." is-full-screen/>

        <div v-if="description!=null" class="card">
            <div class="card-body p-0">
                <div class="ql-snow">
                    <div class="ql-editor">
                        <div v-html="description"></div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import Vue from 'vue';
import Api from './../api';
export default {
    data(){
        return {
            show: false,
            result: null,
            description: null
        }
    },

    created(){
        var obj = this.$route.params;
        this.result = obj.result;
        if(this.result!=undefined){
            this.getThanksActive();
        }else{
            this.$router.push({name: 'errors'});
        }
    },

    watch: {

    },

    methods:{
        getThanksActive(){
            this.show = true;
            this.description = null;
            Api.getThanksActive().then(res => {
                this.show = false;
                var {data} = res;
                console.log(data)
                if(data.result){
                    this.description = data.result.description.split("urlxxx").join(process.env.VUE_APP_API);
                }
            }).catch(err => {
                this.show = false;
                this.$router.push({name: 'errors'});
            })
        },
    }
}
</script>

<style scoped>
    #thanks {
        margin-left: auto;
        margin-right: auto;
        display: block;
        width: 200px;
        height: 200px;
    }
</style>